import { render } from "./peek-worker.vue?vue&type=template&id=b5f6651e&scoped=true"
import script from "./peek-worker.vue?vue&type=script&lang=js"
export * from "./peek-worker.vue?vue&type=script&lang=js"

import "./peek-worker.vue?vue&type=style&index=0&id=b5f6651e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5f6651e"]])

export default __exports__